/**
 * Every outbound request from an embedded activity is routed through
 * Discord's proxy (`https://<app-id>.discordsays.com/.proxy/...`). Keeping the
 * prefix in one place means the rest of the app just calls `api('/profile')`.
 */
const PROXY_PREFIX = '/.proxy';

export function apiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const base = isEmbeddedOrigin() ? `${PROXY_PREFIX}/api` : '/api';
  return `${base}${normalized}`;
}

function isEmbeddedOrigin(): boolean {
  return window.location.hostname.endsWith('discordsays.com');
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(apiUrl(path), {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Request to ${path} failed with status ${response.status}`);
  }

  return (await response.json()) as T;
}
